export interface ISignature {
    displayName: string,
    titles: string[],
    companyName: string,
    html?: string
}